<template>
  <div class="footer-bar">
    <p>
      Copyright &copy; {{new Date().getFullYear()}}湖南柒扣文化科技有限公司版权所有&nbsp; &nbsp;&nbsp;&nbsp;

      <span style="cursor: pointer;" class="footerHover" @click="jumpWeb">湘ICP备2023004439号</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    jumpWeb() {
      window.open("https://beian.miit.gov.cn/");
    }
  }
};
</script>
<style lang="less" scoped>
.footer-bar {
  line-height: 12px;
  p {
    color: #595959;
    font-size: 12px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
  }
}
.footerHover:hover{
color: #64D983;
}
</style>



// WEBPACK FOOTER //
// src/components/public/Footer.vue